import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { TextField, InputAdornment } from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../../components/LoaderScreen";
import request from "../../../../Helpers/API";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import { VendedoresEquipModal } from "./VendedoresEquipModal";

// Listado del catálogo Código-Vendedor (Postventa / Reporte de Refacciones
// / Vendedores Equipo). Alta y edición se hacen con VendedoresEquipModal;
// el listado se recarga cada vez que el modal se cierra.
const VendedoresEquipScreen = () => {
    const history = useHistory();

    const [listado, setListado] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [registroEditar, setRegistroEditar] = useState(null);
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const cargarListado = () => {
        setLoader((prev) => ({ ...prev, mostrar: true }));
        request
            .get("CodigoVendedoresEquip/Listado")
            .then((result) => {
                setListado(result || []);
                setLoader((prev) => ({ ...prev, mostrar: false }));
            })
            .catch(() => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                Swal.fire(
                    "VENDEDORES EQUIPO",
                    "No fue posible cargar el listado. Intente nuevamente o contacte al administrador.",
                    "error"
                );
            });
    };

    // Recarga el listado cada vez que el modal se cierra (después de agregar/editar).
    useEffect(() => {
        if (openModal) return;
        cargarListado();
    }, [openModal]);

    const onAgregar = () => {
        setRegistroEditar(null);
        setOpenModal(true);
    };

    const onEditar = (registro) => {
        setRegistroEditar(registro);
        setOpenModal(true);
    };

    const onCerrarModal = () => {
        setOpenModal(false);
        setRegistroEditar(null);
    };

    // Búsqueda en memoria por código o vendedor (el endpoint no acepta parámetro de búsqueda).
    const listadoFiltrado = listado.filter((fila) => {
        if (!busqueda.trim()) return true;
        const texto = busqueda.trim().toLowerCase();
        return (
            String(fila.codigo || "").toLowerCase().includes(texto) ||
            String(fila.vendedor || "").toLowerCase().includes(texto)
        );
    });

    return (
        <PlantillaScreen
            titulo={"CÓDIGOS DE VENDEDORES"}
            className={"vendedores-equip-main-screen"}
            className_main={1}
        >
            <LoaderScreen loader={loader} />
            <div className="vee-actions">
                <div className="vee-actions-regresar" onClick={() => history.goBack()}>
                    <ArrowBackIcon /> Regresar
                </div>
            </div>

            <div className="vee-container">
                <div className="vee-header">
                    <TextField
                        className="vee-buscador"
                        size="small"
                        label="Buscar"
                        placeholder="Código o vendedor..."
                        value={busqueda}
                        onChange={({ target }) => setBusqueda(target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <button className="vee-agregar" onClick={onAgregar} type="button">
                        <AddCircleOutlineIcon /> Agregar
                    </button>
                </div>

                <div className="vee-tabla scroll-4">
                    <table cellPadding={0} cellSpacing={0}>
                        <thead>
                            <tr>
                                <th>Código</th>
                                <th>Vendedor</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {listadoFiltrado.length === 0 ? (
                                <tr>
                                    <td colSpan={3} className="vee-vacio">
                                        Sin registros para mostrar.
                                    </td>
                                </tr>
                            ) : (
                                listadoFiltrado.map((fila) => (
                                    <tr key={fila.idlistado}>
                                        <td>{fila.codigo}</td>
                                        <td>{fila.vendedor}</td>
                                        <td className="vee-columna-editar">
                                            <div className="vee-boton-editar" onClick={() => onEditar(fila)}>
                                                <EditIcon /> Editar
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <VendedoresEquipModal open={openModal} registro={registroEditar} onClose={onCerrarModal} onGuardado={cargarListado} />
        </PlantillaScreen>
    );
};

export default VendedoresEquipScreen;
